<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      :disabled="disablePopOver"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on" class="focus">
          <img
            v-if="buttonIcon"
            :src="buttonIcon"
            alt="about us"
            style="max-width: 20px"
            class="mr-2"
          />
          {{ buttonText }}
        </v-btn>
      </template>
      <v-card>
        <v-list >
          <v-list-item>
            <v-list-item-title class="text-center">
              <b>{{ titleText }}</b>
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <!-- {{ selectedOption }} -->
        <v-list  class="v-list-custom">
          <v-radio-group
          v-model="selectedOption"
          class="tw-m-0 tw-pt-2"
          >
            <v-list-item  v-for="(option, index) in optionList" :key="index">
              <v-list-item-title>{{ option.label }}</v-list-item-title>
              <v-list-item-action>
                <v-radio
                  :value="option.key"
                  @change="check(option.key)"
                ></v-radio>
              </v-list-item-action>
            </v-list-item>
          </v-radio-group>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "PopoverMenuRadio",
  props: [
    "optionList",
    "titleText",
    "buttonIcon",
    "buttonText",
    "defaultValue",
    "disablePopOver",
  ],
  data: function () {
    return {
      menu: false,
      selectedOption: this.defaultValue,
    };
  },
  methods: {
    check: function (key) {
      this.selectedOption = key;
      this.$emit("change-value-option", key);
    },
  },
};
</script>

<style scoped lang="scss">
.active {
  background-color: #6ec39b;
  color: #ffffff;
}
.v-list-custom {
  padding-top: 0 !important;
}
.v-btn.focus:hover:before,
.v-btn.focus:focus:before {
  background-color: #6ec39b !important;
}
</style>
